import { atom } from 'recoil';

export interface S3File {
  name: string;
  type: string;
  lastModified: Date;
  size: string;
  path: string;
  url: string;
}

// リロード用レンダリング変数
export const fileRenderKeyState = atom<number>({
  key: 'fileRenderKeyState',
  default: 0
});

// S3ブラウジング
export const prefixState = atom<string>({
  key: 'prefixState',
  default: 'model'
});

// アップロード済みモデル
export const allModelsState = atom<S3File[]>({
  key: 'allModelsState',
  default: []
});

// アップロード済みモデルロード
export const allModelsLoadingState = atom<boolean>({
  key: 'allModelsLoadingState',
  default: false
});

// file browser操作で選択されたモデル
export const selectModelsState = atom<S3File[]>({
  key: 'selectModelsState',
  default: []
});

// 描画するモデル
export const displayModelState = atom<S3File | null>({
  key: 'displayModelState',
  default: null
});

// アップロード済みコクーン
export const allCocoonsState = atom<S3File[]>({
  key: 'allCocoonsState',
  default: []
});

// アップロード済みコクーンロード
export const allCocoonsLoadingState = atom<boolean>({
  key: 'allCocoonsLoadingState',
  default: false
});

// file browser操作で選択されたコクーン
export const selectCocoonsState = atom<S3File[]>({
  key: 'selectCocoonsState',
  default: [],
});

// 描画するコクーン
export const displayCocoonState = atom<S3File | null>({
  key: 'displayCocoonState',
  default: null
});

// アップロード済みタイヤ
export const allTiresState = atom<S3File[]>({
  key: 'allTiresState',
  default: []
});

// アップロード済みタイヤロード
export const allTiresLoadingState = atom<boolean>({
  key: 'allTiresLoadingState',
  default: false
});

// file browser操作で選択されたタイヤ
export const selectTiresState = atom<S3File[]>({
  key: 'selectTiresState',
  default: [],
});

// アップロード済みホイールハウス
export const allWheelhousesState = atom<S3File[]>({
  key: 'allWheelhousesState',
  default: []
});

// アップロード済みホイールロード
export const allWheelhousesLoadingState = atom<boolean>({
  key: 'allWheelhousesLoadingState',
  default: false
});

// file browser操作で選択されたホイールハウス
export const selectWheelhousesState = atom<S3File[]>({
  key: 'selectWheelhousesState',
  default: [],
});

// アップロード済みモーフィング済みモデル
export const allMorphedState = atom<S3File[]>({
  key: 'allMorphedState',
  default: []
});

// アップロード済みモーフィング済みモデルロード
export const allMorphedLoadingState = atom<boolean>({
  key: 'allMorphedLoadingState',
  default: false
});

// file browser操作で選択されたモーフィング済みモデル
export const selectMorphedState = atom<S3File[]>({
  key: 'selectMorphedState',
  default: []
});

// 描画するモーフィング済みモデル
export const displayMorphedState = atom<S3File[]>({
  key: 'displayMorphedState',
  default: []
});
